<modal-overlay>
  <box class="no-paddings">
    <div class="row no-gutters flex-column">
      <div class="col-12 mb-5">
        <ng-container *ngIf="collection$ | async as collection">
          <course-exercise-answer-table
            *ngIf="collection.length"
            [answers]="collection$ | async"
            [bulkLoader]="bulkLoader"
            [actualAnswerId]="actualAnswerId"
            (downloadEvent)="handleDownload($event)"
            (downloadBulkEvent)="handleBulkDownload()"
            (failAnswerEvent)="handleFailAnswer($event)"
            (passAnswerEvent)="handlePassAnswer($event)"
            (sortEvent)="handleSort($event)"
          />
        </ng-container>
        <ng-container *ngIf="manualCollection$ | async as manualCollection">
          <course-exercise-answer-table
            *ngIf="manualCollection.length"
            [answers]="manualCollection$ | async"
            [manual]="true"
            (failAnswerEvent)="handleFailAnswer($event)"
            (passAnswerEvent)="handlePassAnswer($event)"
          />
        </ng-container>
      </div>

      <div class="col-12">
        <div class="d-flex justify-content-end p-4">
          <button
            class="theme-hprimarydark px-5 ml-3"
            (click)="handleCloseClick()"
          >
            {{ "GLOBAL.CLOSE_BUTTON" | translate }}
          </button>
        </div>
      </div>
    </div>
  </box>
</modal-overlay>
